import { useMutation } from '@apollo/client'
import { TOGGLE_OVERWRITE_HIPAA } from './operations'
import { ToggleOverwriteHIPAA, ToggleOverwriteHIPAAVariables } from '../../types/operation-types'

type ToggleOverwriteHIPAAProps = {
  onCompleted?: (data: ToggleOverwriteHIPAA) => void
}
export const useToggleOverwriteHIPAA = ({ onCompleted }: ToggleOverwriteHIPAAProps) =>
  useMutation<ToggleOverwriteHIPAA, ToggleOverwriteHIPAAVariables>(TOGGLE_OVERWRITE_HIPAA, {
    onCompleted,
  })
